import type { ProfitLossStatement } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const profitLossKeys = {
  statement: (filters: ReportFilters) => ['reports', 'profit-loss', filters] as const,
};

/** P&L takes only the range and the branch — it has no doc-type split or row filters, as on the POS. */
export function fetchProfitLoss(filters: ReportFilters, signal?: AbortSignal): Promise<ProfitLossStatement> {
  const query = queryString({ branchId: filters.branchId, from: filters.from, to: filters.to });
  return portalApi.get<ProfitLossStatement>(`/portal/reports/profit-loss${query}`, { signal });
}
